"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCheckbox = void 0;
var React = require("react");
var ProductCheckbox_style_1 = require("./ProductCheckbox.style");
var Checkbox_1 = require("../../Checkbox");
var Icon_1 = require("../../Icon");
exports.ProductCheckbox = function (props) {
    var name = props.name, title = props.title, saving = props.saving, image = props.image, checked = props.checked, onChange = props.onChange, isDesktop = props.isDesktop;
    return (React.createElement(ProductCheckbox_style_1.default.Wrap, { checked: checked, isDesktop: isDesktop },
        React.createElement(ProductCheckbox_style_1.default.Container, null,
            React.createElement(ProductCheckbox_style_1.default.ImgWrap, null,
                React.createElement(ProductCheckbox_style_1.default.Image, { src: "https://cdn.getwaterfit.co.uk/static/files/images/products/" + image + ".png", alt: "" })),
            React.createElement(ProductCheckbox_style_1.default.Title, null, title)),
        React.createElement(ProductCheckbox_style_1.default.CheckWrap, null,
            React.createElement(ProductCheckbox_style_1.default.SavingWrap, null,
                React.createElement(Icon_1.default, { icon: "waterCoins", size: 50 }),
                React.createElement("p", null,
                    saving,
                    "L")),
            React.createElement(Checkbox_1.default, { type: "checkbox", name: name, id: name, title: "Select", boxSize: 40, onChange: onChange, checked: checked }))));
};
exports.default = exports.ProductCheckbox;
//# sourceMappingURL=ProductCheckbox.js.map